import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

//api
import { TemplateService } from "../../../../service/template-service";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import DeleteTemplate from "../DeleteTemplate";


const UpdateTemplate = ({templateId}) => {
        // eslint-disable-next-line no-unused-vars
        const [template,setTemplate]= useState()
        const navigate = useNavigate()
        const { register, handleSubmit,setValue, formState: { errors } } = useForm();
        const [selectedStatus, setSelectedStatus] = useState(null)
        const toast = useRef(null);
        
        const status = [
            {name: 'active'},
            {name: 'archived'}
        ]

        //chiamata GET
        useEffect(()=>{
            const fetchTemplate = ()=>{
                TemplateService.getTemplate(
                    templateId,
                    (data)=>{
                        setTemplate(data);
                        setValue('name', data.name);
                        setValue('description', data.description);
                        setValue('file_type', data.file_type)
                        setValue('status', data.status);
                        setValue('destination_folder', data.destination_folder);
                        setSelectedStatus(status.find(s => s.name === data.status) || null); 
                    },
                    (error) => { 
                    console.error("Error fetching template:", error);
                    if (toast.current) {
                        toast.current.show({ severity: 'error', summary: 'Errore', detail: 'Errore durante il recupero del template.' });
                    }
                }
                )
            }
            fetchTemplate();
                
        },[templateId, setValue])
            
        //chiamata PUT
        const onSubmit = (data)=>{
            const payload = {
                id: templateId,
                name: data.name,
                description: data.description || '',
                status: selectedStatus?.name || '',
                destination_folder: data.destination_folder || ''
            }
            
            TemplateService.updateTemplate(
                templateId,
                payload,
                (response)=>{
                    toast.current.show({ severity: 'success', summary: 'Modifica', detail: 'Template modificato!' });
                    navigate('/dashboard/template')
                }
            )
        }

    return (
        <div>
            <form onSubmit={handleSubmit(onSubmit)} className="template__FormWrapper">
                <h3>Modifica Template</h3>
                <div className="p-field addAnalysisFile__InputWrapper">
                    <label htmlFor="name">Nome Template</label>
                    <InputText id="name" {...register('name', { required: 'Il nome del template è obbligatorio' })} className={errors.name ? 'p-invalid' : ''} />
                    {errors.name && <small className="p-error">{errors.name.message}</small>}
                </div>
                <div className="p-field addAnalysisFile__InputWrapper" >
                    <label htmlFor="description">Descrizione</label>
                    <InputTextarea id="description" {...register('description')} rows={5} cols={30} />
                </div>
                <div className="template__DropdownWrapper" style={{margin:'1rem 0'}}>
                    <div className="card template__DropdownInput" style={{marginRight:'2.5rem'}}>
                        <label htmlFor="name">Stato</label>
                        <Dropdown value={selectedStatus} onChange={(e) =>  setSelectedStatus(e.value)} options={status} optionLabel="name" 
                            placeholder="Seleziona uno Status" className="w-full md:w-14rem" style={{margin:'0.5rem 0'}}/>
                    </div>
                    <div className="card template__DropdownInput" >
                        <label htmlFor="name">Cartella di destinazione</label>
                        <InputText id="name" {...register('destination_folder')}  />
                    </div>
                </div>
                <div className="template__ButtonWrapper">
                    <div>
                      <Toast ref={toast} />
                      <Button label="Salva" type="submit"/>  
                    </div>
                    <DeleteTemplate templateId={templateId}/>
                </div>
                
            </form>
        </div>
    )
}

export default UpdateTemplate